import { ContextSetter, setContext } from '@apollo/client/link/context';
import { ApolloLink } from '@apollo/client';
import { useMemo } from 'react';
import { fetchCsrfToken, getCsrfTokenForUser, persistCsrfTokenForUser } from '@tools/csrf';
import { LoggerFactory } from '@cvent/logging/LoggerFactory';

const LOG = LoggerFactory.create('apollo/csrfTokenLink');

/** The custom header for CSRF token sent with request headers to the GraphQL service  */
export const CSRF_TOKEN_HEADER_KEY = 'X-Cvent-CSRF';

export const getCsrfTokenLinkContext = (userId?: string) => {
  const csrfTokenLinkContext: ContextSetter = async (_, { headers }) => {
    let csrfToken;

    // Fetches CSRF token from local/session storage
    if (userId) {
      csrfToken = getCsrfTokenForUser(userId);
    } else {
      LOG.debug('attendeeId is missing. Will not fetch CSRF token.');
    }

    if (window !== undefined && !csrfToken && userId) {
      LOG.warn('CSRF token missing from local/session storage. Fetching token from verify endpoint');
      csrfToken = await fetchCsrfToken();
      persistCsrfTokenForUser(userId, csrfToken);
      if (!csrfToken) {
        LOG.warn('CSRF token still missing from local/session storage after fetching from verify endpoint');
      }
    }

    return {
      headers: {
        ...headers,
        [CSRF_TOKEN_HEADER_KEY]: csrfToken || undefined
      }
    };
  };

  return csrfTokenLinkContext;
};

export const getCsrfTokenLink = (userId: string): ApolloLink => setContext(getCsrfTokenLinkContext(userId));

export const useCsrfTokenLink = (userId: string) => useMemo(() => getCsrfTokenLink(userId), [userId, getCsrfTokenLink]);
